import React from 'react';

import starIcon from '../../../common/images/staking/icon-star.svg';
import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './StakingWallet.module.css';

interface StakingWalletProps {
  walletBal: string;
  onClick: () => void;
  asset: string;
}

export const StakingWallet: React.FC<StakingWalletProps> = ({
  walletBal,
  onClick,
  asset,
}: StakingWalletProps) => {
  return (
    <div className={styles.stakingWalletContainer}>
      <div className={styles.walletInfoContainer}>
        <div className={styles.starsImageContainer}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img src={starIcon} />
        </div>
        <div className={styles.walletDiv}>
          <div className={styles.walletHeader}>WALLET BALANCE</div>
          <div
            className={styles.walletBody}
          >{`${walletBal.toLocaleString()} ${asset} AVAILABLE`}</div>
        </div>
      </div>
      <Button
        color={Colors.COLOR_SCHEME_4}
        className={styles.getMoreButton}
        onClick={onClick}
      >
        GET MORE
      </Button>
    </div>
  );
};
